import AboutTwoAssets from './AboutTwoAssets';

export default AboutTwoAssets;
